module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-backtop",
    class: {
      'is-show': _vm.isShow
    },
    on: {
      "click": _vm.backtop
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ushk-backtop__btn",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_backtop"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57e7425d","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Backtop.vue
// module id = nKiP
// module chunks = 2